var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fictitiousCourse" },
    [
      _c("Search", { on: { toSsearch: _vm.toSsearch } }),
      _vm._v(" "),
      _c("div", { staticClass: "tit" }, [_vm._v("虚拟仿真")]),
      _vm._v(" "),
      _c("div", { staticClass: "courseL" }, [
        _vm.fictitiousCourse.length > 0
          ? _c(
              "div",
              { staticClass: "list" },
              _vm._l(_vm.fictitiousCourse, function (item) {
                return _c(
                  "div",
                  { staticClass: "listItem" },
                  [_c("CourseItem", { attrs: { type: 4, item: item } })],
                  1
                )
              }),
              0
            )
          : _c(
              "div",
              { staticStyle: { "margin-top": "50px", "text-align": "center" } },
              [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
            ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "paginationX" },
        [
          _vm.total > 0
            ? _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.query.pageNum,
                  "page-size": _vm.query.pageSize,
                  layout: "total, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: { "current-change": _vm.handleCurrentChange },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }